"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "fixedAsset",
    path: "/fixed-assets/:id",
    component: "FixedAsset",
    params: [{
            name: "id",
            prop: "fixedAssetId",
        },
    ]
});
let FixedAsset = class FixedAsset extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    fixedAssetId;
    onFixed_asset_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("fixedAssetId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('read_fixed_asset', { asResource: true, parameters: { id: this.fixedAssetId } });
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    messages;
    ux;
    b_7315092382398562_modalBindings;
    b_2285343489561581_to;
    dataMembers = ['item', 'formId', 'messages', 'ux', 'b_7315092382398562_modalBindings', 'b_2285343489561581_to'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                item: null,
                formId: null,
                messages: {
                    delete: this.$fn.pgettext("FixedAsset|Header", "Delete fixed asset"),
                },
                ux: {
                    initialLoadSpinner: true,
                },
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2285343489561581_to: {
                    name: "app.fixedAssets",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: [this.item.snapshot('name'),
                    this.$fn.gettext("Fixed Asset"),
                ],
                icon: this.$config.fixedAsset.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1886_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2095089031469157_clickPreventStop(event, scope) {
        return await this.actions.evh_2095089031469157_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_9004123373732307_success(event, scope) {
        return await this.actions.evh_9004123373732307_success.executeFromDOM(this, event, scope);
    }
    async evh_2679161326024595_reload(event, scope) {
        return await this.actions.evh_2679161326024595_reload.executeFromDOM(this, event, scope);
    }
    async evh_2789477278097085_reload(event, scope) {
        return await this.actions.evh_2789477278097085_reload.executeFromDOM(this, event, scope);
    }
    async evh_8856043737157701_reload(event, scope) {
        return await this.actions.evh_8856043737157701_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1886 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1886_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1885 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1886,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1885],
        });
        const act_2095089031469157_reloadComponentData_1888 = new core_1.actions.ReloadComponentDataAction({
            displayName: "reload",
            events: [],
        });
        const evh_2095089031469157_clickPreventStop_1887 = new core_1.actions.EventHandlerImpl({
            action: act_2095089031469157_reloadComponentData_1888,
            event: "click.prevent.stop",
            displayName: "reload",
        });
        const evh_2095089031469157_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2095089031469157_clickPreventStop_1887],
        });
        const act_9004123373732307_closeComponent_1890 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_9004123373732307_success_1889 = new core_1.actions.EventHandlerImpl({
            action: act_9004123373732307_closeComponent_1890,
            event: "success",
            displayName: "closeComponent",
        });
        const evh_9004123373732307_success = new core_1.actions.EventHandlerGroup({
            handlers: [evh_9004123373732307_success_1889],
        });
        const act_2679161326024595_reloadComponentData_1892 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2679161326024595_reload_1891 = new core_1.actions.EventHandlerImpl({
            action: act_2679161326024595_reloadComponentData_1892,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2679161326024595_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2679161326024595_reload_1891],
        });
        const act_2789477278097085_reloadComponentData_1894 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_2789477278097085_reload_1893 = new core_1.actions.EventHandlerImpl({
            action: act_2789477278097085_reloadComponentData_1894,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_2789477278097085_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2789477278097085_reload_1893],
        });
        const act_8856043737157701_reloadComponentData_1896 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_8856043737157701_reload_1895 = new core_1.actions.EventHandlerImpl({
            action: act_8856043737157701_reloadComponentData_1896,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_8856043737157701_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8856043737157701_reload_1895],
        });
        return {
            act_7315092382398562_closeModal_1886,
            evh_7315092382398562_close_1885,
            evh_7315092382398562_close,
            act_2095089031469157_reloadComponentData_1888,
            evh_2095089031469157_clickPreventStop_1887,
            evh_2095089031469157_clickPreventStop,
            act_9004123373732307_closeComponent_1890,
            evh_9004123373732307_success_1889,
            evh_9004123373732307_success,
            act_2679161326024595_reloadComponentData_1892,
            evh_2679161326024595_reload_1891,
            evh_2679161326024595_reload,
            act_2789477278097085_reloadComponentData_1894,
            evh_2789477278097085_reload_1893,
            evh_2789477278097085_reload,
            act_8856043737157701_reloadComponentData_1896,
            evh_8856043737157701_reload_1895,
            evh_8856043737157701_reload,
            reload: act_2095089031469157_reloadComponentData_1888,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], FixedAsset.prototype, "fixedAssetId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('fixedAssetId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FixedAsset.prototype, "onFixed_asset_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], FixedAsset.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], FixedAsset.prototype, "onSize", null);
FixedAsset = __decorate([
    (0, vue_property_decorator_1.Component)()
], FixedAsset);
exports.default = FixedAsset;
vue_property_decorator_1.Vue.component("FixedAsset", FixedAsset);
